import api from './axiosConfig';
export const getDashboard       = ()         => api.get('/api/v1/reports/dashboard');
export const getAssessmentReport= (id)       => api.get(`/api/v1/reports/assessments/${id}`);
export const getComparison      = (id, sids) => api.get(`/api/v1/reports/assessments/${id}/comparison`, { params: { submission_ids: sids.join(',') } });
export const exportReport       = (id, fmt='csv') => api.get(`/api/v1/reports/export/${id}`, { params: { format: fmt }, responseType: 'blob' });
